"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = exports.checkInterface = void 0;
function getProp(name) {
    const isOptional = name.endsWith('?');
    const prop = isOptional ? name.slice(0, -1) : name;
    return { prop, isOptional };
}
function checkInterface(expectedProps, obj) {
    if (!obj)
        return false;
    for (const prop in expectedProps) {
        const isOptional = prop.endsWith('?');
        const propName = isOptional ? prop.slice(0, -1) : prop;
        if (!isOptional && !obj.hasOwnProperty(propName)) {
            return false;
        }
        if (obj.hasOwnProperty(propName) && typeof obj[propName] !== expectedProps[prop]) {
            return false;
        }
    }
    return true;
}
exports.checkInterface = checkInterface;
function getCallback(a) {
    if (typeof a == 'function')
        return a;
    if (typeof a == 'string') {
        if (a == 'array')
            return (b) => b instanceof Array;
        return (b) => typeof b == a;
    }
    if (a instanceof RegExp)
        return ((b) => {
            if (typeof b !== 'string')
                return false;
            return a.test(b);
        });
    throw 'invalid-validator';
}
class Validator {
    constructor(base) {
        this.errors = [];
        this.base = base;
    }
    get(name, validator, defaultValue = null) {
        const { prop, isOptional } = getProp(name);
        const fn = getCallback(validator);
        if (isOptional && !this.base.hasOwnProperty(prop))
            return defaultValue;
        if (this.base.hasOwnProperty(prop) && fn(this.base[prop]))
            return this.base[prop];
        this.errors.push(prop);
        return null;
    }
    get hasErrors() {
        return this.errors.length > 0;
    }
}
exports.Validator = Validator;
//# sourceMappingURL=validator.js.map